import httpClient from "@hd/http-client/http-client";
import { useMutation } from "@tanstack/react-query";

const request = async (communicationIds: string[]) => {
  const result = await httpClient.patch<boolean>(
    import.meta.env.VITE_HD_API_URL + `/communication/scheduled/confirm`,
    {
      data: communicationIds,
    },
  );
  return result.data;
};

export const useConfirmScheduledCommunicationMutation = () => {
  return useMutation({
    mutationFn: (communicationIds: string[]) => request(communicationIds),
  });
};
